<template>
  <div>
    <RateAgentFilterBox @on-refresh="onRefresh"/>
    <div class="chart-content">
      <div class="bar-chart">
        <RateAgentTimeLine ref="rate_agent_time_line"/>
      </div>
      <div class="donut-chart">
        <RateAgentOverall ref="rate_agent_overall"/>
      </div>
    </div>
  </div>
</template>

<script>
import RateAgentTimeLine from "@/views/rating-report/RateAgentTimeLine";
import RateAgentOverall from "@/views/rating-report/RateAgentOverall";
import RateAgentFilterBox from "@/views/rating-report/RateAgentFilterBox";

export default {
  name: "RateAgentOverview",
  components: {
    RateAgentFilterBox,
    RateAgentOverall,
    RateAgentTimeLine,
  },
  methods: {
    onRefresh() {
      this.$refs.rate_agent_time_line.refresh()
      this.$refs.rate_agent_overall.refresh()
    }
  }
}
</script>

<style scoped lang="scss">
.chart-content {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  .bar-chart {
    border: 1px solid #EDEDF2;
    border-radius: 5px;
    background-color: white;
    flex-grow: 2;
    padding: 10px;
  }
  .donut-chart {
    border: 1px solid #EDEDF2;
    border-radius: 5px;
    background-color: white;
    flex-grow: 1;
    padding: 10px;
  }
}
</style>